import { User } from "../../responseModels/User";

export abstract class _Account {
  id: any;
  name: any;
  createdById: any;
  _brand: string;
  ownerAccountManager: User;

}